import React from "react";

const withProcessSteps = ( steps, type, monetisationData, currentStep, totalSteps, seperatorText, toggleFeedback ) => WrappedComponent => {
	const ProcessWithSteps = () => {
		const StepComponent = steps[currentStep];
		const stepData      = monetisationData?.monetisationData?.[currentStep];

		return (
			<StepComponent
				currentStep       = { currentStep }
				monetisationData  = { monetisationData }
				seperatorText     = { seperatorText }
				stepData          = { stepData }
				toggleFeedback    = { toggleFeedback }
				totalSteps        = { totalSteps }
				type              = { type }
			/>
		);
	};

	return ProcessWithSteps;
};

export default withProcessSteps;
